import { FC, ReactNode } from 'react';
import { capitalCase } from 'change-case';
import { Tr, TypeUtils } from '@utils';
import { useService } from '@hooks';
import { adminService } from '@services';
import { Grid, IconButton, Stack, Typography } from '@mui/material';
import { LightCardWithTitle } from '@components/common';
import SyncIcon from '@mui/icons-material/Sync';

const KPI: FC<{ value: ReactNode; description: ReactNode; border?: boolean }> = ({ value, description, border }) => {
	return (
		<Grid
			item
			xs={4}
			sx={{
				flexGrow: 1,
				borderBottomWidth: border ? 1 : 0,
				borderBottomStyle: border ? 'solid' : 'none',
				borderBottomColor: 'grey.100'
			}}
		>
			<Stack
				direction="column"
				spacing={0.5}
				sx={{
					paddingY: 2
				}}
			>
				{TypeUtils.isDefined(value) ? <Typography variant="h4">{value}</Typography> : null}
				{TypeUtils.isDefined(description) ? (
					<Typography variant="body2" sx={{ maxWidth: 180 }}>
						{description}
					</Typography>
				) : null}
			</Stack>
		</Grid>
	);
};

export interface IAdminDashboardStatisticsProps {}

export const AdminDashboardStatistics: FC<IAdminDashboardStatisticsProps> = () => {
	const { data: statistics, trigger: fetchStatistics } = useService(() => adminService.getStatistics());

	return (
		<LightCardWithTitle
			headerVariant="dark"
			title={<Tr.Portal path="admin-dashboard.statistics" />}
			actionButton={
				<Stack direction="row" alignItems="center" spacing={1} onClick={fetchStatistics}>
					<Typography sx={{ cursor: 'pointer' }}>
						<Tr.Portal path="admin-dashboard.refresh" />
					</Typography>
					<IconButton size="small" sx={{ color: 'inherit' }}>
						<SyncIcon color="inherit" />
					</IconButton>
				</Stack>
			}
		>
			<Grid container>
				{Object.entries(statistics || []).map(([key, value], i, all) => {
					return (
						<KPI key={`statistic-${key}`} value={value} description={capitalCase(key)} border={all.length - 3 >= i}>
							{value}
						</KPI>
					);
				})}
			</Grid>
		</LightCardWithTitle>
	);
};
